<template>
  <DefaultLayout>
    <section class="contact-section spad">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
            <div class="contact-form">
              <div class="leave-comment">
                <h4>{{ $t("sentence.leaveAComment") }}</h4>
                <p>{{ $t("sentence.weWillContactYou") }}</p>
                <form action="#" class="comment-form">
                  <div class="row">
                    <div class="col-lg-6">
                      <input type="text" placeholder="Your name" />
                    </div>
                    <div class="col-lg-6">
                      <input type="text" placeholder="Your email" />
                    </div>
                    <div class="col-lg-12">
                      <textarea placeholder="Your message"></textarea>
                      <button type="submit" class="btn-site">
                        {{ $t("action.sendMessage") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
export default {
  components: {
    DefaultLayout
  }
}
</script>
<style scoped>
/*---------------------
  Contact Section
-----------------------*/

.contact-section {
  padding-top: 45px;
  padding-bottom: 80px;
}

.contact-title {
  margin-bottom: 30px;
}

.contact-title h4 {
  color: var(--dark);
  font-weight: 700;
  margin-bottom: 16px;
}

.contact-widget .cw-item {
  background: white;
  margin-bottom: 11px;
  -webkit-box-shadow: 0px 8px 35px 10px #e8e8e8;
  box-shadow: 0px 8px 35px 10px #e8e8e8;
  padding-left: 25px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 10px;
}

.contact-widget .cw-item .ci-icon {
  float: left;
  margin-top: 12px;
}

.contact-widget .cw-item .ci-icon i {
  font-size: 30px;
  color: #b2b2b2;
}

.contact-widget .cw-item .ci-text {
  display: table;
  padding-left: 30px;
}

.contact-widget .cw-item .ci-text span {
  color: #b2b2b2;
  font-size: 16px;
}

.contact-widget .cw-item .ci-text p {
  font-size: 18px;
  color: var(--dark);
  margin-bottom: 0;
}

.contact-form .leave-comment h4 {
  color: #292f3b;
  font-weight: 700;
  margin-bottom: 20px;
}

.contact-form .leave-comment p {
  margin-bottom: 38px;
}

.contact-form .leave-comment .comment-form input {
  width: 100%;
  font-size: 16px;
  color: #636363;
  height: 50px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding-left: 20px;
  margin-bottom: 30px;
}

.contact-form .leave-comment .comment-form textarea {
  width: 100%;
  resize: none;
  font-size: 16px;
  color: #636363;
  height: 150px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding-left: 20px;
  padding-top: 10px;
  margin-bottom: 35px;
}

.contact-form .leave-comment .comment-form .btn-site {
  padding: 13px 35px 11px;
}


@media (max-width: 767px) {
  .contact-section {
    padding-top: 10px;
    padding-bottom: 40px;
  }
}
</style>